import { breakpoints } from "@authentic/loyalty-pwa/util/variables";
import styled from "styled-components";

export const TierInfoStyled = styled.div`
  margin-left: 8px;
  margin-right: 8px;
  background-color: white;
`;

export const DetailStyled = styled.ul`
  list-style: none;
  padding: 0;
  li {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    > div {
      width: 120px;
      flex: 0 0 120px;
      margin-right: 9px;
    }
    > p {
      flex: 1;
      font-size: 14px;
      padding-left: 9px;
    }
  }
`;

export const ImageStyled = styled.div`
  text-align: right;
`;